import { useState } from 'react';
import invalidateCaches from '../helpers/invalidateCaches';

const TRANSACTION_ERROR_CODE = 'TRANSACTION_ERROR';

const useShowErrorOrRedirectThankYouPageV2 = (history, thankYouPagePath, couponCode) => {
  const initialState = {
    showPayment: false,
    errorPaymentMessage: '',
    showRetry: false,
    isLoading: false,
  };

  const [currentState, setCurrentState] = useState(initialState);

  const setLoading = (loadingBool) => {
    setCurrentState({
      ...initialState,
      isLoading: loadingBool,
    });
  };

  const onClose = () => {
    setCurrentState(initialState);
  };

  const handlePlanChangeResponse = async (response) => {
    if (response.ok) {
      invalidateCaches();
      history.push({
        pathname: thankYouPagePath,
        state: { coupon_code: couponCode || '' },
      });
    } else if (response.status === 422) {
      const body = await response.json();
      if (body.errorCode === TRANSACTION_ERROR_CODE) {
        setCurrentState({
          ...initialState,
          showPayment: true,
          errorPaymentMessage: body.message,
        });
      } else {
        setCurrentState({
          ...initialState,
          showRetry: true,
        });
      }
    } else {
      setCurrentState({
        ...initialState,
        showRetry: true,
      });
    }
  };

  return {
    ...currentState,
    onClose,
    handlePlanChangeResponse,
    setLoading,
  };
};

export default useShowErrorOrRedirectThankYouPageV2;
